import type { MemberStatus, OrgMemberResponse } from './types';

/** Checklist order, and the only list of statuses the filter knows about. */
export const MEMBER_STATUS_ORDER: readonly MemberStatus[] = [
  'active',
  'pending',
  'expired',
  'deactivated',
];

export const MEMBER_STATUS_LABELS: Record<MemberStatus, string> = {
  active: 'Active',
  pending: 'Pending invite',
  expired: 'Expired invite',
  deactivated: 'Deactivated',
};

/**
 * Opens on the people who can still be scheduled. Every other state is one
 * somebody goes looking for on purpose rather than reads past.
 */
export const DEFAULT_MEMBER_STATUS_FILTER: readonly MemberStatus[] = ['active'];

export const MEMBER_STATUS_OPTIONS = MEMBER_STATUS_ORDER.map(status => ({
  value: status,
  label: MEMBER_STATUS_LABELS[status],
}));

/**
 * The one state a member is in for the filter's purposes. Deactivation wins
 * over a pending invitation: their access is gone either way, and listing them
 * under an invitation nobody can now accept would be a lie.
 */
export function memberStatus(member: OrgMemberResponse): MemberStatus {
  if (member.deactivated_at) return 'deactivated';
  if (!member.is_pending) return 'active';
  // A pending invitation that has not lapsed carries no invite_status, so an
  // absent value is the pending case rather than an unknown one.
  return member.invite_status === 'expired' ? 'expired' : 'pending';
}
